import { faker } from "@msuite/mocking/faker";
import { Divider } from "@msuite/ui/divider";
import { LicensePlateInput, Select, TextInput } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import {
	fuelTypes,
	type VehicleFormSchema,
	vehicleManufacturers,
	vehicleTypes,
} from "@msuite/utils/schemas";
import { useFormContext } from "react-hook-form";

const placeholderVin = faker.vehicle.vin();

export function VehicleFormGeneral() {
	/** Context */
	const methods = useFormContext<VehicleFormSchema>();

	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="v-stack gap-4">
			<LicensePlateInput
				label={t("vehicles.license_plate")}
				isRequired
				control={methods.control}
				name="licensePlate"
			/>
			<Select
				isRequired
				label={t("general.type")}
				itemNotFoundLabel={t("general.not_found")}
				control={methods.control}
				name="type"
				isNullable={false}
				options={vehicleTypes.map((type) => ({
					value: type,
					label: t(`vehicles.types.${type}`),
					item: {
						type,
					},
				}))}
				data-cy="vehicle-type-select"
			/>
			<Select
				isRequired={false}
				label={t("vehicles.manufacturer")}
				control={methods.control}
				name="manufacturer"
				options={vehicleManufacturers.map((manufacturer) => ({
					value: manufacturer,
					label: manufacturer,
					item: {
						manufacturer,
					},
				}))}
				itemNotFoundLabel={t("general.not_found")}
				data-cy="vehicle-manufacturer-select"
			/>
			<Select
				isRequired
				label={t("vehicles.fuel_type")}
				control={methods.control}
				name="fuelType"
				options={fuelTypes.map((fuelType) => ({
					value: fuelType,
					label: t(`vehicles.fuel_types.${fuelType}`),
					item: {
						fuelType,
					},
				}))}
				itemNotFoundLabel={t("general.not_found")}
				data-cy="vehicle-fuel-type-select"
			/>
			<Divider variant="modal" />
			<TextInput
				isRequired={false}
				label={t("vehicles.vin")}
				className="font-mono uppercase"
				control={methods.control}
				name="vin"
				placeholder={placeholderVin}
				data-cy="vehicle-vin-input"
			/>
			<div className="grid grid-cols-2 gap-4">
				<TextInput
					isRequired={false}
					label={t("vehicles.hsn")}
					control={methods.control}
					name="hsn"
					placeholder="ABC"
					data-cy="vehicle-hsn-input"
				/>
				<TextInput
					isRequired={false}
					label={t("vehicles.tsn")}
					control={methods.control}
					name="tsn"
					placeholder="1473"
					data-cy="vehicle-tsn-input"
				/>
			</div>
		</div>
	);
}
